import { render, staticRenderFns } from "./payComeBack.vue?vue&type=template&id=1f67c33f&scoped=true"
import script from "./payComeBack.vue?vue&type=script&lang=js"
export * from "./payComeBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f67c33f",
  null
  
)

export default component.exports